export default {
  'documentTypes.generateReport': 'Generate Report',
  'documentTypes.create': 'New Documet Type',
  'documentTypes.filters.initials': 'Intial',
  'documentTypes.filters.description': 'Description',
  'documentTypes.list.header.initials': 'Intial',
  'documentTypes.list.header.description': 'Description',
  'documentTypes.list.header.actions': 'Actions',
  'documentTypes.list.column.actions.details': 'View/Edit',
  'documentTypes.modal.general.new.title': 'New Document Type',
  'documentTypes.modal.general.form.initials': 'Inital',
  'documentTypes.modal.general.form.description': 'Description',
  'documentTypes.modal.general.form.percentRate': 'Percent Rate (%)',
  'documentTypes.modal.general.form.creditCard': 'Credit Card',
  'documentTypes.modal.general.form.debitCard': 'Debit Card',
  'documentTypes.modal.general.form.fiscalDocument': 'Fiscal Document',
  'documentTypes.modal.general.form.fixedRate': 'Fixed Rate',
  'documentTypes.modal.general.form.notGenerateFinancial':
    'Not Generate Financial',
  'documentTypes.modal.general.form.includeBankAccountInPaymentInstallments':
    'Include bank account in payment installments',
  'documentTypes.modal.general.form.stoneDocument': 'Stone Document',
  'documentTypes.modal.general.form.payOnTime': 'Pay on Time',
  'documentTypes.modal.general.form.calculateValue':
    'Calculates the tariff value on the total financial value',
  'documentTypes.modal.general.form.bankAccounts': 'Bank Account',
  'documentTypes.modal.general.form.planAccounts': 'Standard Chart of Accounts',
  'documentTypes.modal.report.title': 'Generate Report',
  'documentTypes.modal.report.buttons.viewReport': 'View Report',
  'documentTypes.modal.report.buttons.pdf': 'Generate PDF',
  'documentTypes.modal.report.buttons.rtf': 'Generate RTF',
  'documentTypes.modal.report.buttons.csv': 'Generate CSV',
  'document.modal.report.form.since': 'Since',
  'document.modal.report.form.until': 'Until',
  'document.modal.report.form.description': 'Description',
  'document.modal.report.form.fiscalDocument': 'Fiscal Document',
  'document.modal.report.form.fiscalDocument.yes': 'Yes',
  'document.modal.report.form.fiscalDocument.no': 'No',
  'documentTypes.rate.list.title': 'Rates',
  'documentTypes.rates.modal.create.success': 'New Rate created with success',
  'documentTypes.rates.modal.create.error': 'Error to create New Rate',
  'documentTypes.rate.list.numberInstallments': 'Installments',
  'documentTypes.rate.list.percentRate': 'Percent Rate (%)',
  'documentTypes.rate.list.header.actions': 'Actions',
  'documentTypes.rate.form.numberInstallments': 'Installments',
  'documentTypes.rate.form.percentRate': 'Percent Rate (%)',
  'documentTypes.remove': 'Remove Document Type',
  'documentTypes.remove.alert':
    'Do you wnato to remove the current Document Type?',
  'documentTypes.remove.notification.success': 'Document Type removed!',
  'documentTypes.remove.notification.success.description':
    'Document Type removed with success!',
  'documentTypes.remove.notification.error': 'Error to remove Document Type!',
  'documentTypes.remove.notification.error.description':
    'Error to remove Document Type!',
  'documentTypes.update.notification.success': 'Document Type Updated',
  'documentTypes.update.notification.success.description':
    'Document type updated successfully',
  'documentTypes.update.notification.error': 'Error updating Document Type',
  'documentTypes.update.notification.error.description':
    'An error occurred while updating Document Type',
  'documentTypes.rate.remove.modal.title': 'Delete Rate',
  'documentTypes.rate.remove.modal.content': 'Do you want to delete the rate?',
  'documentTypes.rate.remove.notification.success': 'Rate Deleted',
  'documentTypes.rate.remove.notification.successDescription':
    'Rate deleted successfully',
  'documentType.rate.remove.modal.button.ok': 'Delete',
  'documentTypes.rate.list.create': 'Create Rate',
  'documentTypes.rate.modal.create.title': 'Create new Rate',
  'documentTypes.rate.modal.create.success': 'Rate created',
  'documentTypes.rate.modal.create.successDescription':
    'Rate created successfully',
  'documentTypes.rate.modal.create.error': 'Create rate error',
  'documentTypes.rate.modal.create.errorDescription':
    'There was an error creating rate',

  'documentTypes.rate.modal.update.title': 'Update Rate',
  'documentTypes.rate.modal.update.success': 'Rate updated',
  'documentTypes.rate.modal.update.successDescription':
    'Rate updated successfully',
  'documentTypes.rate.modal.update.error': 'Error updating rate',
  'documentTypes.rate.modal.update.errorDescription':
    'An error occurred while updating the rate',
  'documentTypes.notification.generate.report.description':
    'Successfully Generated Document Types Report!',
  'documentTypes.notification.generate.report.title':
    'Report Generated Successfully',

  'documentType.notification.update.status':
    'Document Type status changed successfully!',

  'documentTypes.modal.selectedDcocumentTypes.title.add': 'Add Document Type',
  'documentTypes.modal.selectedDcocumentTypes.search':
    'Search for Document Types',

  'documentTypes.create.error.duplicate.initials':
    'Document Types already created with the abbreviation provided.',
  'documentTypes.create.error.duplicate.description':
    'Document Types already created with the abbreviation provided.',
};
